module.exports = __webpack_public_path__ + "img/marina.8e3e0226.png";